const busyActionFactory = ( actionType ) => {
    return ( busy ) => {
        return {
            type: actionType,
            busy
        };
    };
};
 export default busyActionFactory;
